export const statusColor = (status: boolean | number) => {
  if (status === 2) {
    return 'StatusBar_on-hold'
  } else if (status === true || status === 1) {
    return 'StatusBar_active'
  } else if (status === false || status === 0) {
    return 'StatusBar_blocked'
  } else {
    return
  }
}
